import { Main } from "./components/Main";
import styles from "./App.module.scss";
import { Header } from "./components/Header/Header";
import { Footer } from "./components/Footer/Footer";
import { Transfers } from "./components/Transfers/Transfers";

export function App() {
  return (
    <div className={styles.app}>
      <Header />
      <Main />
      <Transfers />
      <Footer />
    </div>
  );
}
